<div
  class="ag-paging-panel ag-unselectable mainPagination"
  [ngStyle]="checkPaginationStatus ? { 'margin-top': '40px' } : { 'margin-top': '0px' }"
>
  <div class="showPagination">
    <span
      class="ag-paging-row-summary-panel ag-status-bar-left"
      style="display: flex; vertical-align: middle; align-items: center"
    >
      <span class="ag-paging-description"> Show </span>
      <ng-select
        [clearable]="false"
        [items]="numberList"
        bindLabel="value"
        [(ngModel)]="selectedOption"
        class="customPagination pagination-icon"
        (change)="onPageSizeChanged($event)"
        [searchable]="false"
      >
      </ng-select>
      <span class="ag-paging-description entriesspace"> entries</span>
    </span>
    <span class="ag-paging-row-summary-panel showEntires">
      <span> Showing </span>
      <span class="ag-paging-row-summary-panel-number">{{ startCount }}</span>
      <span> to </span>
      <span class="ag-paging-row-summary-panel-number">{{ endCount || 0 }}</span>
      <span> of </span>
      <span class="ag-paging-row-summary-panel-number">{{ totalCount }}</span>
      <span> entries </span>
      <span *ngIf="totalRecord !== totalCount"
        >(filtered from {{ totalRecord }} total entries)</span
      >
    </span>
  </div>

  <div class="rightsidepaging">
    <span
      class="ag-paging-page-summary-panel ag-status-bar-right"
      role="presentation"
      *ngIf="!isHidePagination"
    >
      <ul class="pagination pageallright">
        <ngb-pagination
          class="custom-pagination"
          [collectionSize]="totalCount"
          #numPagesExp3
          [(page)]="currentPage"
          [pageSize]="pageSize"
          [maxSize]="3"
          [rotate]="true"
          [ellipses]="false"
          [boundaryLinks]="true"
          (pageChange)="onPageNumberClicked(currentPage)"
          [size]="'custom'"
        >
          <ng-template ngbPaginationPrevious>
            <span class="far fa-chevron-left"></span>
          </ng-template>
          <ng-template ngbPaginationNext>
            <span class="fa fa-chevron-right"></span>
          </ng-template>
        </ngb-pagination>
      </ul>
    </span>
    <div class="range-container">
      <span class="range-value">{{ range }}</span>
    </div>
  </div>
</div>
